! function() {
    "use strict";

    function t(t, e) {
        if (!(t instanceof e)) throw new TypeError("Cannot call a class as a function")
    }

    function e(t, e) {
        for (var i = 0; i < e.length; i++) {
            var n = e[i];
            n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n)
        }
    }

    function i(t, i, n) {
        return i && e(t.prototype, i), n && e(t, n), Object.defineProperty(t, "prototype", {
            writable: !1
        }), t
    }

    function n(t) {
        if (void 0 === t) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
        return t
    }

    function r(t, e) {
        return r = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
            return t.__proto__ = e, t
        }, r(t, e)
    }

    function s(t, e) {
        if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
        t.prototype = Object.create(e && e.prototype, {
            constructor: {
                value: t,
                writable: !0,
                configurable: !0
            }
        }), Object.defineProperty(t, "prototype", {
            writable: !1
        }), e && r(t, e)
    }

    function o(t) {
        return o = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(t) {
            return typeof t
        } : function(t) {
            return t && "function" == typeof Symbol && t.constructor === Symbol && t !== Symbol.prototype ? "symbol" : typeof t
        }, o(t)
    }

    function l(t, e) {
        if (e && ("object" === o(e) || "function" == typeof e)) return e;
        if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
        return n(t)
    }

    function u(t) {
        return u = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(t) {
            return t.__proto__ || Object.getPrototypeOf(t)
        }, u(t)
    }

    function c(t, e, i) {
        return c = function() {
            if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
            if (Reflect.construct.sham) return !1;
            if ("function" == typeof Proxy) return !0;
            try {
                return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0
            } catch (t) {
                return !1
            }
        }() ? Reflect.construct.bind() : function(t, e, i) {
            var n = [null];
            n.push.apply(n, e);
            var s = new(Function.bind.apply(t, n));
            return i && r(s, i.prototype), s
        }, c.apply(null, arguments)
    }

    function a(t) {
        var e = "function" == typeof Map ? new Map : void 0;
        return a = function(t) {
            if (null === t || (i = t, -1 === Function.toString.call(i).indexOf("[native code]"))) return t;
            var i;
            if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
            if (void 0 !== e) {
                if (e.has(t)) return e.get(t);
                e.set(t, n)
            }

            function n() {
                return c(t, arguments, u(this).constructor)
            }
            return n.prototype = Object.create(t.prototype, {
                constructor: {
                    value: n,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                }
            }), r(n, t)
        }, a(t)
    }! function(e) {
        s(o, e);
        var r = function(t) {
            var e = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0
                } catch (t) {
                    return !1
                }
            }();
            return function() {
                var i, n = u(t);
                if (e) {
                    var r = u(this).constructor;
                    i = Reflect.construct(n, arguments, r)
                } else i = n.apply(this, arguments);
                return l(this, i)
            }
        }(o);

        function o() {
            var e;
            return t(this, o), (e = r.call(this)).isDown = !1, e.startX, e.velX = 0, e.momentumID, e.left = 0, e.lastEvent, e.prevButton = e.querySelector(".prev"), e.nextButton = e.querySelector(".next"), e.slide = e.querySelector(".slider-item"), e.slider = e.querySelector(".slider"), getComputedStyle(e.slide), getComputedStyle(e.slider), e.slider.addEventListener("mousemove", e.mousemove.bind(n(e)), !1), e.slider.addEventListener("mousedown", e.mousedown.bind(n(e)), !1), e.slider.addEventListener("mouseup", e.mouseup.bind(n(e)), !1), e.prevButton && e.nextButton && (e.prevButton.addEventListener("click", e.onButtonClick.bind(n(e))), e.nextButton.addEventListener("click", e.onButtonClick.bind(n(e)))), e
        }
        i(o, [{
            key: "onButtonClick",
            value: function(t) {
                t.preventDefault(), this.slider.classList.remove("active"), this.slideScrollPosition = "next" === t.currentTarget.name ? this.slider.scrollLeft + this.slide.offsetWidth : this.slider.scrollLeft - this.slide.offsetWidth, this.slider.scrollTo({
                    left: this.slideScrollPosition
                })
            }
        }, {
            key: "mousedown",
            value: function(t) {
                this.isDown = !0, this.startX = t.pageX - this.slider.offsetLeft, this.left = this.slider.scrollLeft, this.cancelMomentumTracking()
            }
        }, {
            key: "mouseleave",
            value: function(t) {
                this.isDown = !1
            }
        }, {
            key: "mouseup",
            value: function(t) {
                this.isDown = !1, this.lastEvent = null, this.beginMomentumTracking()
            }
        }, {
            key: "mousemove",
            value: function(t) {
                if (this.isDown) {
                    t.preventDefault();
                    var e = t.pageX - this.slider.offsetLeft - this.startX,
                        i = this.slider.scrollLeft;
                    this.lastEvent && !this.slider.classList.contains("active") && this.speed(t, this.lastEvent) > 2 && this.slider.classList.add("active"), this.slider.scrollLeft = this.left - e, this.velX = this.slider.scrollLeft - i, this.lastEvent = t
                }
            }
        }, {
            key: "speed",
            value: function(t, e) {
                var i = Math.abs(t.screenX - e.screenX),
                    n = Math.abs(t.screenY - e.screenY),
                    r = Math.sqrt(i * i + n * n);
                return Math.round(r)
            }
        }, {
            key: "beginMomentumTracking",
            value: function() {
                var t = this;
                this.cancelMomentumTracking(), this.momentumID = requestAnimationFrame(function() {
                    return t.momentumLoop()
                })
            }
        }, {
            key: "cancelMomentumTracking",
            value: function() {
                cancelAnimationFrame(this.momentumID)
            }
        }, {
            key: "momentumLoop",
            value: function() {
                var t = this;
                this.slider.scrollLeft += 2 * this.velX, this.velX *= .95, Math.abs(this.velX) > 2 ? this.momentumID = requestAnimationFrame(function() {
                    return t.momentumLoop()
                }) : this.slider.classList.remove("active")
            }
        }])
    }(a(HTMLDivElement));
    // customElements.get("slideshow-component") || customElements.define("slideshow-component", d, {
    //     extends: "div"
    // });
    var d = function(e) {
        s(r, e);
        var n = function(t) {
            var e = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0
                } catch (t) {
                    return !1
                }
            }();
            return function() {
                var i, n = u(t);
                if (e) {
                    var r = u(this).constructor;
                    i = Reflect.construct(n, arguments, r)
                } else i = n.apply(this, arguments);
                return l(this, i)
            }
        }(r);

        function r() {
            var e;
            return t(this, r), (e = n.call(this)).slideshow = e.querySelector(".slideshow"), e.slide = e.slideshow.querySelector(".slide"), e.slides = e.querySelectorAll(".slide").length, e.slideCurrent = 0, e.slides > 1 && e.init(), e
        }
        return i(r, [{
            key: "init",
            value: function() {
                var t, e = this;
                this.prevButton = this.querySelector(".prev"), this.nextButton = this.querySelector(".next"), this.prevButton.addEventListener("click", this.onButtonClick.bind(this)), this.nextButton.addEventListener("click", this.onButtonClick.bind(this)), this.dots = Array.from(this.querySelectorAll("[data-dot]")), this.dots.forEach(function(t) {
                    t.addEventListener("click", e.toSlide.bind(e))
                }), this.addEventListener("mouseover", this.over.bind(this)), this.addEventListener("mouseleave", this.out.bind(this)), this.addEventListener("focusin", this.over.bind(this)), this.addEventListener("focusout", this.out.bind(this)), this.slideshow.addEventListener("scroll", this.scroll.bind(this)), this.autoplaySpeed = 1e3 * this.slideshow.dataset.speed, this.autoplayMode = null !== (t = this.slideshow.dataset.start) && void 0 !== t ? t : 0, 1 == this.autoplayMode && this.play()
            }
        }, {
            key: "play",
            value: function() {
                this.slideshow.setAttribute("aria-live", "off"), clearInterval(this.autoplay), this.autoplay = setInterval(this.autoSlide.bind(this), this.autoplaySpeed)
            }
        }, {
            key: "pause",
            value: function() {
                this.slideshow.setAttribute("aria-live", "polite"), clearInterval(this.autoplay), this.autoplay = null
            }
        }, {
            key: "out",
            value: function(t) {
                this.autoplay || 1 != this.autoplayMode || this.play()
            }
        }, {
            key: "over",
            value: function(t) {
                this.autoplay && this.pause()
            }
        }, {
            key: "scroll",
            value: function(t) {
                this.slideCurrent = Math.ceil(this.slideshow.scrollLeft / this.slide.clientWidth), this.dot()
            }
        }, {
            key: "autoSlide",
            value: function() {
                this.slideCurrent++, this.slideCurrent + 1 > this.slides && (this.slideCurrent = 0), this.doSlide()
            }
        }, {
            key: "doSlide",
            value: function() {
                var t = this.slide.clientWidth * this.slideCurrent;
                this.slideshow.scrollTo({
                    left: t
                })
            }
        }, {
            key: "dot",
            value: function() {
                this.dots.length && (this.dots.forEach(function(t) {
                    t.classList.remove("dot-active"), t.removeAttribute("aria-current")
                }), this.dots[this.slideCurrent].classList.add("dot-active"), this.dots[this.slideCurrent].setAttribute("aria-current", !0))
            }
        }, {
            key: "toSlide",
            value: function(t) {
                t.preventDefault(), this.pause(), this.slideCurrent = t.currentTarget.dataset.slide, this.doSlide()
            }
        }, {
            key: "onButtonClick",
            value: function(t) {
                t.preventDefault(), this.pause(), this.slideCurrent = "next" === t.currentTarget.name ? this.slideCurrent + 1 : this.slideCurrent - 1, this.slideCurrent + 1 > this.slides ? this.slideCurrent = 0 : this.slideCurrent < 0 && (this.slideCurrent = this.slides - 1), this.doSlide()
            }
        }]), r
    }(a(HTMLDivElement));
    // customElements.define("slideshow-component", d, {
    //     extends: "div"
    // })
}();